import { render, staticRenderFns } from "./Sing.vue?vue&type=template&id=a7ea8486&scoped=true"
import script from "./Sing.vue?vue&type=script&lang=js"
export * from "./Sing.vue?vue&type=script&lang=js"
import style0 from "./Sing.vue?vue&type=style&index=0&id=a7ea8486&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ea8486",
  null
  
)

export default component.exports